import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from "axios";
import VueAxios from 'vue-axios'
import {createMetaManager} from "vue-meta";
import {clickLog} from "@/js/common";
createApp(App)
    .use(store)
    .use(router)
    .use(VueAxios, axios)
    .use(ElementPlus)
    .use(createMetaManager())
    .use(clickLog)
    .mount('#app')
